export default "__VITE_ASSET__077e6f17__"